<div class="dialog-wrapper">
  <button class="close-btn" type="button" (click)="cancel()">
    <mat-icon>close</mat-icon>
  </button>

  <h2 class="dialog-title">{{ 'fee.register_to_subgroup' | translate }}</h2>

  @if (loading) {
    <div class="loading-state">
      <mat-progress-spinner mode="indeterminate" diameter="32"></mat-progress-spinner>
    </div>
  } @else {

    <div class="selected-field">
      <span class="selected-field-label">{{ 'fee.selected_groups_subgroups' | translate }}</span>
      <div class="selected-field-value">
        <span class="selected-field-text">{{ selectedLabel || '\u00a0' }}</span>
        <mat-icon class="dropdown-arrow">keyboard_arrow_up</mat-icon>
      </div>
    </div>

    <div class="options-list">
      @if (options.length === 0) {
        <div class="option-row">
          <span class="option-text">{{ 'fee.no_available_subgroups' | translate }}</span>
        </div>
      } @else {
        @for (opt of options; track opt.subgroupId; let i = $index) {
          <label class="option-row" [class.selected]="opt.selected">
            <input type="checkbox" class="sr-only"
                   [checked]="opt.selected"
                   (change)="toggleOption(i, $any($event.target).checked)">
            <span class="custom-check" [class.checked]="opt.selected">
              @if (opt.selected) {
                <mat-icon>check</mat-icon>
              }
            </span>
            <span class="option-text">{{ opt.groupName }} ({{ opt.subgroupName }})</span>
          </label>
        }
      }
    </div>
  }

  <div class="dialog-actions">
    <button type="button" class="btn-cancel" (click)="cancel()">{{ 'Cancel' | translate }}</button>
    <button type="button" class="btn-save" [disabled]="saving || loading || !canSave" (click)="save()">
      @if (saving) {
        <mat-progress-spinner diameter="16" mode="indeterminate"></mat-progress-spinner>
      } @else {
        {{ 'user_card.save' | translate }}
      }
    </button>
  </div>
</div>
